import { SecureImage } from '../ng-images/bg-image.models';
import { genThumbMediaURI, getImageByType, getPrimaryImageOrFirst, isMediaInfoPublishable } from './image-utils';
import { MediaContentType, PropertyMediaInfo } from './image.models';

export function getPrimarySecureImage(
  recordMediaArray: PropertyMediaInfo[],
  altRecordMedia: PropertyMediaInfo[],
  options: {
    urlSplitter: string;
    urlPrefix: string;
    onlyUrl: boolean;
    provideDefault?: boolean;
    isPDF?: boolean;
  }
): string | SecureImage {
  const { urlSplitter, urlPrefix, provideDefault = true, onlyUrl = true, isPDF = false } = options;
  let primaryImage = getPrimaryImageOrFirst(recordMediaArray);
  primaryImage = primaryImage != null ? primaryImage : getPrimaryImageOrFirst(altRecordMedia);
  let result: SecureImage = {
    imageSrc: genThumbMediaURI(urlSplitter, urlPrefix, primaryImage != null ? primaryImage.media_path : null, {
      provideDefault,
    }),
    publishable: isMediaInfoPublishable(primaryImage as PropertyMediaInfo),
    isPDF,
  };
  return onlyUrl ? (result.imageSrc as string) : result;
}

export function getSecureImageByType(
  _type: MediaContentType,
  recordMediaArray: PropertyMediaInfo[],
  altRecordMedia: PropertyMediaInfo[],
  options: {
    urlSplitter: string;
    urlPrefix: string;
    onlyUrl: boolean;
    provideDefault?: boolean;
    isPDF?: boolean;
  }
): string | SecureImage {
  const { urlSplitter, urlPrefix, provideDefault = true, onlyUrl = true, isPDF = false } = options;
  let primaryImage = getImageByType(recordMediaArray);
  primaryImage = primaryImage != null ? primaryImage : getImageByType(altRecordMedia);
  let result: SecureImage = {
    imageSrc: genThumbMediaURI(urlSplitter, urlPrefix, primaryImage != null ? primaryImage.media_path : null, {
      provideDefault,
    }),
    publishable: isMediaInfoPublishable(primaryImage as PropertyMediaInfo),
    isPDF,
  };
  return onlyUrl ? (result.imageSrc as string) : result;
}
